import { render, staticRenderFns } from "./charCardPriceIndex.vue?vue&type=template&id=16853065&scoped=true"
import script from "./charCardPriceIndex.vue?vue&type=script&lang=js"
export * from "./charCardPriceIndex.vue?vue&type=script&lang=js"
import style0 from "./charCardPriceIndex.vue?vue&type=style&index=0&id=16853065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16853065",
  null
  
)

export default component.exports